/**
 * Constants for AuditLogViewerAuditorLeftBody component
 */

import type { FilterOption, SortOption } from './types';

// Filter options
export const FILTER_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
  { value: 'deviation', label: 'With Deviations' },
  { value: 'no-deviation', label: 'Without Deviations' },
  { value: 'high-usage', label: 'High Usage' },
  { value: 'low-usage', label: 'Low Usage' },
];

// Sort options
export const SORT_OPTIONS: SortOption[] = [
  { value: 'name-asc', label: 'Name (A-Z)' },
  { value: 'name-desc', label: 'Name (Z-A)' },
  { value: 'usage-count-desc', label: 'Usage Count (High to Low)' },
  { value: 'usage-count-asc', label: 'Usage Count (Low to High)' },
  { value: 'duration-desc', label: 'Duration (High to Low)' },
  { value: 'duration-asc', label: 'Duration (Low to High)' },
];

// Tab configuration
export const TAB_CONFIG = {
  'transaction-overview': {
    label: 'Transaction Overview',
    value: 'transaction-overview',
  },
  'all-logs': {
    label: 'All Logs',
    value: 'all-logs',
  },
} as const;

// CSS class names
export const CSS_CLASSES = {
  ROOT: 'AuditLogViewerAuditorLeftBody',
  TABS_SECTION: 'AuditLogViewerAuditorLeftBody-tabsSection',
  TABS: 'AuditLogViewerAuditorLeftBody-tabs',
  TABLE_SECTION: 'AuditLogViewerAuditorLeftBody-tableSection',
  ALL_LOGS: 'AuditLogViewerAuditorLeftBody-allLogs',
  LIST_CONTROLS: 'AuditLogViewerAuditorLeftBody-listControls',
  SEARCH_INPUT: 'AuditLogViewerAuditorLeftBody-searchInput',
  FILTER_BUTTON: 'AuditLogViewerAuditorLeftBody-filterButton',
  SORT_BUTTON: 'AuditLogViewerAuditorLeftBody-sortButton',
  TRANSACTION_LIST: 'AuditLogViewerAuditorLeftBody-transactionList',
  TRANSACTION_ITEM: 'AuditLogViewerAuditorLeftBody-transactionItem',
  TRANSACTION_ICON: 'AuditLogViewerAuditorLeftBody-transactionIcon',
  TRANSACTION_CONTENT: 'AuditLogViewerAuditorLeftBody-transactionContent',
  TRANSACTION_HEADER: 'AuditLogViewerAuditorLeftBody-transactionHeader',
  TRANSACTION_TITLE: 'AuditLogViewerAuditorLeftBody-transactionTitle',
  DEVIATION_CHIP: 'AuditLogViewerAuditorLeftBody-deviationChip',
  TRANSACTION_DETAILS: 'AuditLogViewerAuditorLeftBody-transactionDetails',
  TRANSACTION_ATTRIBUTE: 'AuditLogViewerAuditorLeftBody-transactionAttribute',
  TRANSACTION_ACTIONS: 'AuditLogViewerAuditorLeftBody-transactionActions',
  ACTION_BUTTON: 'AuditLogViewerAuditorLeftBody-actionButton',
} as const;
